/*eslint-disable */

import React, { useState } from 'react';
import Icon from './Icon';
import Label from './Label';
import Section from './Section';
import Wrapper from './Wrapper';
import PropTypes from 'prop-types';
import Svg from '_assets/svg';
import Chevron from './Chevron';
import ChildMenu from './ChildMenu';
import SelectedMenu from './SelectedMenu';
import { useHistory } from 'react-router-dom';
import ActiveMenu from './ActiveMenu';

const MenuSidebar = (props) => {
  const { id, active, data, icon, iconActive, title, onClick } = props;
  const [activeDropdown, setActiveDropdown] = useState(false);
  const history = useHistory();

  const handleActive = () => {
    if (data && data.length > 0) {
      setActiveDropdown(!activeDropdown);
    } else {
      onClick();
    }
    return true;
  }

  return (
    <div className="menu-sidebar">
      <Wrapper className="noselect" active={active && !data} onClick={handleActive}>
        <Section>
          <div className="d-flex align-items-center justify-content-center">
            <Icon src={active ? iconActive : icon} />
            <Label className='ms-2'>{title}</Label>
          </div>
          {data && data.length > 0 && <Chevron active={activeDropdown} src={Svg.chevron_right.default} />}
        </Section>
      </Wrapper>
      <div className="d-flex flex-row w-100 child-menu">
        <SelectedMenu />
        <div className="d-flex flex-column w-100">
          {activeDropdown && data.map(val => {
            return (
              <ChildMenu
                key={val.id}
                onClick={() => history.push(`${id}${val.id}`)}
                active={location.pathname.indexOf(`${id}${val.id}`) >= 0}
                className="d-flex flex-row w-100 position-relative text-nowrap"
              >
                {location.pathname.indexOf(`${id}${val.id}`) >= 0 && <ActiveMenu />}
                <Label child>{val.title}</Label>
              </ChildMenu>
            )
          })}
        </div>
      </div>
    </div>
  )
}

MenuSidebar.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func
}

MenuSidebar.defaultProps = {
  title: "",
  onClick: undefined
}

export default MenuSidebar;